/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_VerifyInputs */

const cs_gdpr_audit_verify = /** @type {(inputs: Gdpr_Audit_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřit integritu`)
};

const en_gdpr_audit_verify = /** @type {(inputs: Gdpr_Audit_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify integrity`)
};

/**
* | output |
* | --- |
* | "Verify integrity" |
*
* @param {Gdpr_Audit_VerifyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_verify = /** @type {((inputs?: Gdpr_Audit_VerifyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_VerifyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_verify(inputs)
	return cs_gdpr_audit_verify(inputs)
});